module.exports = __webpack_public_path__ + "d63b5195b31e3362f72c9d78c6226e26.png";